import React from 'react';
import HotKeyComponent from '../../common/hotkey/hot-key-component';
import HotkeyModal from '../../common/hotkey/hotkey-modal';
import { entityTaggingShortcutList, imageAnnotationShortcutList, transcriptionShortcutList, videoShortcutList } from './const';
const getShortcutList = (labelingType: 'IMAGE' | 'VIDEO' | 'ENTITY_TAGGING' | 'DATA_CLASSIFICATION' | 'GEN_AI_LABELING' | 'PDF' | 'TRANSCRIPTION' | undefined) => {
  switch (labelingType) {
    case 'ENTITY_TAGGING':
      return entityTaggingShortcutList;
    case 'VIDEO':
      return videoShortcutList;
    case 'IMAGE':
      return imageAnnotationShortcutList;
    case 'TRANSCRIPTION':
      return transcriptionShortcutList;
    default:
      return [];
  }
};
export const KeyboardShortcutsModal = ({
  isOpen,
  setIsOpen,
  labelingType
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  labelingType: 'IMAGE' | 'VIDEO' | 'ENTITY_TAGGING' | 'DATA_CLASSIFICATION' | 'GEN_AI_LABELING' | 'PDF' | 'TRANSCRIPTION' | undefined;
}) => {
  return <HotkeyModal isModalOpen={isOpen} setIsModalOpen={setIsOpen} showDivider={labelingType !== 'TRANSCRIPTION'}>
      <HotKeyComponent shortcutList={getShortcutList(labelingType)} />
    </HotkeyModal>;
};